import TitTip from "@/components/titTip.vue"
export default function(vue){
    vue.component("MyTitle",TitTip)
}